export default __webpack_public_path__ + "static/media/4.2e26ce8c.png";